import { simpleApiClient } from '../../axios';
import { IntervalRes } from './types';

export * from './types';

export const getIntervalsApi = (
  symbol: string,
  resolution: string,
  fromSec: number,
  toSec: number,
  params: Partial<Record<'priceType', string>>,
) =>
  simpleApiClient.get<IntervalRes>(`/v2/chart/klines/${symbol}/${resolution}/${fromSec}-${toSec}`, {
    params,
    // 차트에서 getIntervalsApi를 부를 때 오류가 발생하면 언젠가는 성공할 것을 기대하고 재시도를 하고 있음.
    // 계속해서 오류가 돌아오면 무한 재시도가 일어남.
    // 상장일보다 오래된 블록을 요청하면 404가 돌아올 수 있는데, 이는 무한 재시도를 일으킬 수 있으므로 에러를 발생시키지 않도록 함.
    // 너무 많이 요청했을 때는 429가 돌아올 수 있고, 위와 같은 이유로 에러를 발생시키지 않도록 함.
    // context: https://prextech.slack.com/archives/C07AYLQPUE9/p1720421231733939?thread_ts=1720419954.850979&cid=C07AYLQPUE9
    validateStatus: (status) => status === 404 || status === 429 || status < 400,
  });
